<template>
  <router-view />
</template>

<script>
  import { EventBus } from './plugins/event-bus'
  export default {
    name: 'App',
    mounted: function () {
      EventBus.$on('loggedIn', this.loggedIn)
      if (localStorage.getItem('token')) {
        this.loggedIn()
      }
    },
    methods: {
      loggedIn: function () {
        if (!this.$store.state.carriers?.length) {
          this.$get('selects/carriers').then((res) => {
            this.$store.commit('SET_CARRIERS', res.data)
          })
        }
      },
    },
  }
</script>
